import { UiLibrary } from 'learning-panel-components';

export const {
    // icons
    AccessAlarmSharp,
    ArrowDropDownIcon,
    ArrowDropUpIcon,
    KeyboardArrowDownIcon,
    CheckIcon,
    ErrorIcon,
    CreateIcon,
    ArrowBack,
    CloseIcon,
    DotIcon,
    TimerIcon,
    GroupIcon,
    ArrowDownwardIcon,
    FiberManualRecordIcon,
    MoreVertOutlinedIcon,
    CheckCircleOutlineIcon,
    HighlightOffIconIcon,
    MaximizeIcon,
    SentimentVeryDissatisfied,
    ArrowBackIosIcon,
    ArrowForwardIosIcon,
    SearchIcon,
    ZoomInIcon,
    ArrowRightIcon,
    ArrowLeftIcon,
    InfoIcon,
    CropSquareIcon,
    LinkIcon,
    HelpOutlineIcon,
    // styles
    ThemeProvider,
    useMediaQuery,
    makeStyles,
    createStyles,
    withStyles,
    useTheme,
    // components
    Card,
    Input,
    CardContent,
    CardActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    Menu,
    FormHelperText,
    Divider,
    TextField,
    DialogActions,
    Avatar,
    Checkbox,
    Chip,
    Table,
    TableContainer,
    TableBody,
    TableRow,
    TableCell,
    ButtonGroup,
    CircularProgress,
    InputAdornment,
    Paper,
    TableHead,
    Snackbar,
    Slide,
    IconButton,
    List,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Tooltip,
    LinearProgress,
    ClickAwayListener,
    Radio,
    FormControlLabel,
    PlayArrowIcon
} = UiLibrary;
